<template>
    <div>
        <el-form label-width="90px">
            <el-row>
                <el-col :span="10">
                    <el-form-item label="名称">
                        <el-select v-model="filter.id"
                                   placeholder="请选择"
                                   clearable
                                   style="width:200px"
                                   @change="handleChooseClassHour()">
                            <el-option
                                    v-for="item in $parentInfo.studentCart.dialog_UseClassHour.studentClassHours"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="剩余课次">
                        <el-input v-model="filter.has_period"
                                  disabled
                                  style="width:80px"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="使用课次">
                        <el-input v-model="filter.use_period"
                                  placeholder="请输入课次"
                                  style="width:100px"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="text-right">
            <el-button type="primary" @click="handleUse()">确定
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_ChooseClassHour",
        data(){
            return{
                semesters:[],
                classHours:[],
                filter: {
                        id:'',
                        has_period:'',
                        use_period:'',
                }

            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleStudentClassHours();
        },
        destroyed(){
            this.filter= {
                    id:'',
                    has_period:'',
                    use_period:'',
                }

        },
        methods: {
            handleStudentClassHours(){
                this.$wApi.send(this.$parentInfo.path, 'get_studentClassHour_from_cart_id', {
                    'student_id':this.$parentInfo.student_id,
                    'cart_id':this.$store.state.modal.data.cart_id
                })
            },
            handleChooseClassHour(){
                if(this.filter.id!==''){
                    let studentClassHour=this.$parentInfo.studentCart.dialog_UseClassHour.studentClassHours[this.filter.id]
                    this.filter.has_period=studentClassHour.period
                }else{
                    this.filter.has_period=''
                }

            },
            handleUse(){
                this.$wApi.send(this.$parentInfo.path, 'use_studentClassHour_to_cart', {
                    'use_period':this.filter.use_period,
                    'student_id':this.$parentInfo.student_id,
                    'cart_id':this.$store.state.modal.data.cart_id
                })
            }
        }
    }
</script>

<style scoped>

</style>